/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import { getBraindateConversation } from '@braindate/domain/lib/braindate/util';

import styles from './CheckInTakeOver.style';

import messages from 'src/shared/app/check-in/l10n/checkInTakeOverL10n';
import useEventBraindateName from 'src/shared/domain/event/hook/useEventBraindateName';
import {
  isConversationAboutGroupBraindate,
  isConversationAboutFishbowl,
} from 'src/shared/domain/conversation/util/conversationUtil';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import CheckInActionButton from 'src/shared/app/check-in/component/notification/CheckInActionButton';

type Props = {
  braindate: Braindate,
  onClick?: () => void,
};

const useStyles = createUseThemeStyles(styles);

const CheckInTakeOverVirtualAction = ({
  braindate,
  onClick,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const { braindateSingular } = useEventBraindateName();
  const conversation = getBraindateConversation(braindate);
  const isFishbowl = isConversationAboutFishbowl(conversation);
  const isGroupBraindate = isConversationAboutGroupBraindate(conversation);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  return (
    <div className={classes.meeting}>
      <p className={classes.instructions}>
        {isFishbowl
          ? intl.formatMessage(messages.takeOverFishbowlCTA)
          : intl.formatMessage(messages.takeOverCTA, {
              isGroupBraindate,
              braindateSingular,
            })}
      </p>
      <CheckInActionButton braindate={braindate} onClick={onClick} />
    </div>
  );
};

export default React.memo<Props>(CheckInTakeOverVirtualAction);
